module.exports = __webpack_public_path__ + "img/33_47.32c119ca.png";